const content = {
  modalCloseLinkLabel: 'Close',
  faq: {
    title: 'FAQs',
    ariaLabel: 'Frequently asked questions',
  },
  mainpage: {
    title: 'Choose your SIM!',
    ctaText: 'GG Button',
    ctaLink: '/orders',
  },
  chooseSim: {
    title: 'Choose your SIM',
    subTitleV2:
      'Connect with eSIM today or get a plastic SIM with free next-day delivery.',
    eSimRadioLabel: 'eSIM',
    plasticSimRadioLabel: 'Plastic SIM',
    recommendedBadgeText: 'Recommended',
    EsimTitle: 'Why choose eSIM',
    EsimText1: 'Start using your plan in minutes',
    EsimText2: 'No plastic, better for the planet',
    EsimText3: 'Hassle-free, no SIM tray or fiddly pins',
    PlasticSimTitle: 'Get your plastic SIM with next-day delivery',
    PlasticSimText1:
      'Order your giffgaff plastic SIM before 5pm for free next-day delivery.',
    downloadAppForEsim:
      'Once you’ve created an account, just download our app to activate your eSIM.',

    downloadAppForPlasticSim:
      'Once you’ve received your plastic SIM, just download our app to activate it.',
    eSimCompatibilityAlertTitle: 'Check if your phone’s eSIM compatible',
    eSimCompatibilityAlertDescription:
      'Not all phones support eSIM. Make sure yours is compatible before getting started.',
    eSimCompatibilityAlertModalLink: 'See compatible phones',
    CTAbutton: 'Get started',
    FAQTitle: 'FAQs',
    FAQText1: "What's an eSIM?",
    FAQText2: 'Can I keep my number?',
  },
  eSimCompatibilityModal: {
    title: 'Is my phone eSIM compatible?',
    description:
      'eSIM is still fairly new, so only works with more recent phones. As a quick guide, here are some phones that support eSIM.',
    alternativeCompatibilityCheckDescriptionPart1:
      'This isn’t a full list. Some newer phones not listed here might also support eSIM. If you’re not sure, ',
    alternativeCompatibilityCheckDescriptionPart2: 'dial *#06#',
    screenReaderOnly_AlternativeCompatibilityCheckDescriptionPart2:
      'dial star hash zero six hash',
    alternativeCompatibilityCheckDescriptionPart3:
      ". If you see an EID number, you're good to go.",
  },
  canIkeepMyNumberModal: {
    title: 'Can I keep my number?',
    description:
      'You sure can. You just need a PAC code from your current UK network',
    steps1Part1: '1. Text ',
    steps1Part2: 'PAC',
    steps1Part3: ' to ',
    steps1Part4: '65075',
    steps1Part5: ' from your current SIM. You’ll get a code in 60 seconds',
    steps2:
      "2. Activate your giffgaff SIM (you'll get a temporary number for the time being)",
    steps3Part1: '3. Once your SIM is active, log in and pop over to ',
    steps3Part2: 'Profile and Settings',
    steps3Part3: ', then ',
    steps3Part4: 'Bring a number to giffgaff',
    steps3Part5: ' to enter your PAC',
    steps4:
      "4. When you enter your PAC, you'll be asked to pick a number transfer day. " +
      "That day, you'll have intermittent service from your old provider and giffgaff up until 9pm",
    steps5: "5. Success. You've now moved your number over to giffgaff",
  },
  whatIsAnEsimModal: {
    title: "What's an eSIM?",
    description:
      "An eSIM is a digital SIM that's built into your phone. This means you can get a plan in minutes without having to wait for your SIM card to arrive in the post.",
  },
  keepNumber: {
    title: 'Keep your number',
    description: {
      part1: 'Just text ',
      part2: 'PAC',
      part3: ' to ',
      part4: '65075',
      part5: " from your current SIM. You'll get a PAC code in 60 seconds.",
    },
    CTAbutton: 'Confirm',
    pacSubmissionErrorTitle: 'There was an error submitting your PAC code.',
    pacSubmissionErrorDescription: 'Please try again or skip to it later.',
    skipLink: "I'll do this later",
    skipLinkAriaLabel: 'Skip keeping number process and get a new number',
    FAQText1: 'What happens after I give you my PAC code?',
  },
  keepingNumber: {
    title: "Your number's on the move",
    description1: "That's it for now.",
    description2: 'Once you activate, the number transfer will start.',
    CTAbutton: 'Continue to checkout',
  },
  keepNumberAlert: {
    title: 'Moving your number usually takes 1 business day',
    description:
      "If you activate your SIM after 5pm, it can take up to 2 business days. This doesn't include weekends or bank holidays.",
  },
  pacCodeSubmissionModal: {
    title: 'What happens after I give you my PAC code?',
    description:
      "Once you activate your SIM, we'll move your number within 1 business day (or 2 business days if it's after 5pm).",
    transferDayTitle: 'On the day of the transfer:',
    transferStep1:
      "Both SIMs will stop working. This doesn't always happen at the same time",
    transferStep2:
      'Your giffgaff SIM will start working again. This can take anywhere from 10 minutes to a few hours',
    transferStep3:
      'Calls, texts, and data will start working again gradually throughout the day',
    conclusion:
      "As soon as everything's up and running, you'll be able to use your number on your giffgaff SIM.",
  },
}
export default content
